import React, { useState } from "react";
import { useInfiniteQuery } from "@tanstack/react-query";
import axios from "axios";
import ShowMoreButton from "@components/elements/input/ShowMoreButton";
import { useSearchParams } from "react-router-dom";
import { JobType } from "@/utils/types/JobType";
import JobsListItem from "@pages/jobs/JobsListItem";
import Input from "@/components/elements/input/Input";
import api from "@/api/api";
import { useAppSelector } from "@/state/hooks";
import { useTranslation } from "react-i18next";

type Response = {
  data: JobType[];
  current_page: number;
  total_pages: number;
};

const Jobs = () => {
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();
  const jobs = useInfiniteQuery<Response>(
    ["jobs", searchQuery],
    async ({ pageParam = 0 }) => {
      const { data } = await api.get(
        `/api/v1/jobs?page=${pageParam}&q=${searchQuery}`,
      );
      return data;
    },
    {
      getNextPageParam: (lastPage) => {
        const nextPage = lastPage.current_page + 1;
        return nextPage <= lastPage.total_pages ? nextPage : false;
      },
    },
  );
  const { user } = useAppSelector((state) => state.user);

  if (!user) return null;

  return (
    <div className="flex flex-col gap-3">
      <Input
        placeholder={t("main.jobsTabs.placeholder")}
        name="jobs_keywords"
        onChange={(e) => setSearchQuery(e)}
        clearable
      />
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        {jobs.data &&
          jobs.data.pages.map(
            (page) =>
              page.data &&
              page.data.map((job: JobType) => (
                <JobsListItem key={job.id} job={job} showButtons={false} />
              )),
          )}
      </div>

      {jobs.hasNextPage && !jobs.isFetchingNextPage && (
        <ShowMoreButton onClick={() => jobs.fetchNextPage()} />
      )}
    </div>
  );
};

export default Jobs;
